import { NavLink as RouterNavLink, Outlet } from 'react-router-dom';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { PageHeader } from '../../components/PageHeader';
import { useMe } from '../../me/MeProvider';

/**
 * Shared Layout für /me und /me/security.
 * Tabs oben, Inhalt darunter via Outlet.
 */
export function MeLayout() {
  const { me } = useMe();
  return (
    <div>
      <PageHeader
        title="Mein Profil"
        subtitle={me?.user?.email ?? '—'}
      />
      <Nav tabs className="mb-3">
        <NavItem>
          <NavLink tag={RouterNavLink} end to="/me">
            Profil
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink tag={RouterNavLink} to="/me/security">
            Sicherheit & MFA
          </NavLink>
        </NavItem>
      </Nav>
      <Outlet />
    </div>
  );
}
